module.exports = __webpack_public_path__ + "static/media/splitCheckFirstScreen.099e7219.png";